import services from "../services";
import i18n from "./../i18n";
import dayjs from "dayjs";
import findIndex from "lodash/findIndex";
import isEmpty from "lodash/isEmpty";
import forEach from "lodash/forEach";

const strict = true;

const getDefaultState = () => {
  return {
    toSearch: "",
    multiSelectConfig: {
      items: ["video-tutorials", "newsletter", "rules", "manuals", "news-hf"],
      activeItems: []
    },
    sortConfig: {
      list: ["A-Z", "Z-A"],
      order: "A-Z"
    },
    dateConfig: {
      range: {
        dateFrom: null,
        dateTo: null
      },
      type: "past",
      calendarMode: 3
    },
    pagination: {
      page: 1,
      size: 4,
      isPageChanged: false
    },
    filterCriteriaResults: "",
    newsTutorial: [],
    newsTutorialFullList: [],
    numberOfNews: 0
  };
};

const state = getDefaultState();

const getters = {
  items: state => state.newsTutorial,
  itemById: state => id => {
    return state.newsTutorial.find(
      newsTutorialItem => newsTutorialItem.id == id
    );
  },
  toSearch: state => state.toSearch,
  multiSelectFullList: state => state.multiSelectConfig.items,
  multiSelectActiveList: state => state.multiSelectConfig.activeItems,
  dateRange: state => state.dateConfig.range,
  orderList: state => state.sortConfig.list,
  order: state => state.sortConfig.order,
  dateType: state => state.dateConfig.type,
  dateCalendarMode: state => state.dateConfig.calendarMode,
  page: state => state.pagination.page,
  size: state => state.pagination.size,
  filterCriteriaResults: state => state.filterCriteriaResults,
  totalItems: state => state.numberOfNews
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_TO_SEARCH(state, toSearch) {
    state.toSearch = toSearch;
  },
  SET_MULTI_SELECT_ACTIVE_LIST(state, multiSelectItem) {
    state.multiSelectConfig.activeItems = multiSelectItem;
  },
  removeMultiSelectItem(state, multiSelectItem) {
    let index = findIndex(
      state.multiSelectConfig.activeItems,
      item => item === multiSelectItem
    );
    state.multiSelectConfig.activeItems.splice(index, 1);
  },
  updateDateRange(state, dateRange) {
    state.dateConfig.range = dateRange;
  },
  SET_ORDER(state, order) {
    state.sortConfig.order = order;
  },
  updateDateCalendarMode(state, calendarMode) {
    state.dateConfig.calendarMode = calendarMode;
  },
  updatePage(state, page) {
    state.pagination.page = page;
    state.pagination.isPageChanged = true;
  },
  updateSize(state, size) {
    state.pagination.size = size;
    state.pagination.isPageChanged = false;
  },
  setIsPageChanged(state, isPageChanged) {
    state.pagination.isPageChanged = isPageChanged;
  },
  SET_FILTER_CRITERIA_RESULTS(state) {
    let criteria = [];
    if (state.toSearch) {
      criteria.push("'" + state.toSearch + "'");
    }

    let activeMultiSelectItems = state.multiSelectConfig.activeItems;
    if (!isEmpty(activeMultiSelectItems)) {
      let translatedActiveItems = [];
      forEach(activeMultiSelectItems, item => {
        translatedActiveItems.push(
          i18n.t(`baseFilters.newsTutorial.${item}Checkbox`).toUpperCase()
        );
      });
      criteria.push("'" + translatedActiveItems.join(", ") + "'");
    }

    let dateFrom = state.dateConfig.range.dateFrom;
    let dateTo = state.dateConfig.range.dateTo;

    if (dateFrom || dateTo) {
      const DATE_FORMAT = "DD/MM/YYYY";
      let formatDateFrom = dateFrom ? dayjs(dateFrom).format(DATE_FORMAT) : "";
      let formatDateTo = dateTo ? dayjs(dateTo).format(DATE_FORMAT) : "";
      criteria.push("'" + formatDateFrom + " - " + formatDateTo + "'");
    }

    state.filterCriteriaResults = criteria.join(" & ");
  },
  setNewsTutorial(state, newsTutorial) {
    state.newsTutorial = newsTutorial;
  },
  setNewsTutorialFullList(state, newsTutorial) {
    state.newsTutorialFullList = newsTutorial;
  },
  setNumberOfNews(state, numberOfNews) {
    state.numberOfNews = numberOfNews;
  }
};

const actions = {
  getItems({ commit, state }) {
    if (!state.pagination.isPageChanged) {
      commit("updatePage", 1);
    }

    let parameters = {
      toSearch: state.toSearch,
      toFilter: state.multiSelectConfig.activeItems.join(","),
      dateFrom: state.dateConfig.range.dateFrom,
      dateTo: state.dateConfig.range.dateTo,
      page: state.pagination.page,
      order: state.sortConfig.order
    };

    return services.newsTutorialService
      .fetchNewsTutorial(parameters)
      .then(newsTutorial => {
        commit("setNewsTutorial", newsTutorial.newsTutorialList);
        commit("setNewsTutorialFullList", newsTutorial.newsTutorialList); //TODELETE
        commit("setNumberOfNews", newsTutorial.numberOfNews);

        commit("setIsPageChanged", false);
        return newsTutorial;
      })
      .catch(() => {})
      .finally(() => {
        commit("SET_FILTER_CRITERIA_RESULTS");
      });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
